var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.isRallyLoaded)?_c('RallyNav',{attrs:{"rally":this.rally,"channel":this.channel},on:{"perform":_vm.perform}}):_vm._e()],1),(_vm.isRallyLoaded && _vm.isChannelLoaded)?_c('div',[_c(_vm.channelComponent,{key:_vm.channel.attributes.slug,tag:"component",attrs:{"rally":_vm.rally,"channel":_vm.channel}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }